import { error } from 'console';
import wretch from 'wretch';

export async function callWp(method: string, action: string, data: any = {}) {
	const ajaxUrl = silkNexusWp.ajaxUrl;

	action = 'silk_nexus_wp_plugin_' + action;

	if (data instanceof FormData) {
		data.append('action', action);
	} else {
		data.action = action;
	}

	let url = ajaxUrl;

	try {
		let response;

		if (method === 'GET') {
			let parameters;
			if (data instanceof FormData) {
				parameters = [...data.entries()].map((e) => encodeParam(e));
			} else {
				parameters = Object.entries(data).map((e) => encodeParam(e));
			}
			url += '?' + parameters.join('&');

			response = await wretch(url).get();
		} else if (method === 'POST') {
			if (data instanceof FormData) {
				response = await wretch(url).body(data).post();
			} else {
				response = await wretch(url).formData(data, true).post();
			}
		} else {
			throw new Error(`Unimplemented HTTP Request Method ${method}`);
		}

		try {
			const json = await response.json();
			return json;
		} catch (e) {
			return null;
		}
	} catch (e) {
		throw new Error(`[Booking] There was an error with the request`);
	}
}

function encodeParam(e: [string, unknown]): string {
	if (e[1] === null || e[1] === undefined) {
		return '';
	}

	if (e[1] instanceof Boolean || typeof e[1] === 'boolean') {
		return encodeURIComponent(e[0]) + '=' + encodeURIComponent(e[1] ? '1' : '0');
	}

	if (e[1] instanceof Array) {
		const params: string[] = [];

		e[1].forEach((value) => params.push(encodeURIComponent(e[0]) + '[]=' + encodeURIComponent(value as any)));

		return params.join('&');
	}

	return encodeURIComponent(e[0]) + '=' + encodeURIComponent(e[1] as any);
}
